import React from "react";
import "./Marquee.css";

function Marquee() {
  return (
    <section className="marquee">
      <div className="marquee-content">
        <h1 className="style-h1">News</h1>
        <p>
          Read all the latest Sendbird news, from press releases to company
          announcements and more.
        </p>
      </div>
    </section>
  );
}

export default Marquee;